import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePceSearchV2 from './usePceSearchV2'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const PceSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { updatePceConfigData } = usePceSearchV2()

  const handleOpenModal = () => {
    updatePceConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <SDButton
      overrides={{
        BaseButton: {
          style: () => ({
            height: '100%',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            letterSpacing: '-0.176px',
          }),
        },
      }}
      size={SIZE.compact}
      id='pce-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pce_module.search_text_v2')}
    </SDButton>
  )
}

export default PceSearchButton
